import { HelmetDexteel } from "@dexteel/mesf-core";
import { ShiftsReport } from "./components/ShiftsReport";

export const ShiftsPage = () => (
	<>
		<HelmetDexteel title="Shifts" />
		<ShiftsReport />
	</>
);
